<template>
    <div>
        <template v-if="crud_department === true">
            <div class="container">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left">Edit Department</h1>
                </div>
                <div class="global-main">
                    <form @submit.prevent="editDepartmentData">
                        <div class="tab-content-inner">
                            <div class="form-group">
                                <label> Name </label>
                                <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                <has-error :form="form" field="name"></has-error>
                            </div>
                            
                        </div>
                        <div class="form-group">
                            <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                            <router-link to="/departments" class="btn btn-primary float-right mr-2">Cancel</router-link>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-if="crud_department === null"><preLoader></preLoader></template>
        <template v-if="crud_department === false"><notAllowed></notAllowed></template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                }),
                crud_department : null,
            };
        },
        methods: {
            editDepartmentData() {
                this.$Progress.start();
                this.form.put('/api/updateDepartment')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Department updated successfully');
                        this.$router.push('/departments');
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getDepartmentData(){
                axios.get('/api/editDepartment/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.id = res.data.id;
                        this.form.name = res.data.name;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_department').then(result=>{
                this.crud_department = result.crud_department;
            }).then(result=>{
                this.getDepartmentData();
                this.$Progress.finish();
            })
        }
    }
</script>